require('./bootstrap');

window.Vue = require('vue');

import VueQrcodeReader from 'vue-qrcode-reader'
Vue.use(VueQrcodeReader)

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
    camelCase(
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    )
  )

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

if(document.getElementById("app") != undefined) {
  const app = new Vue({
      el: '#app',
      data() {
        return {
          params: {},
          sending: false,
          msg: '',
          has_error: false,
          show_details: false,
          message: '',
          blur: false,
          winner: {
            id:null
          },
        }
      },
      methods: {
        handleMenu() {
          this.showMenu = !this.showMenu
          if (this.showMenu)
            document.body.style.overflow = "hidden"
          else
            document.body.style.overflow = ""
        },
        validateParams(t_p, t_s, f_o, opt) {
          let vm = this
          let s = {}
          if (t_s == 'register') {
            if (_.isEmpty(t_p.register)) {
              f_o.status = true
            } else {
              s = _.find(opt, function (o) {
                return o.id == t_p.register
              })
              if (!s) {
                t_p.register = f_o.id
                vm.setTabsWithParamsMain(opt)
                vm.updateHistory(f_o.id, t_s)
              } else {
                vm.setTabsWithParamsMain(opt)
              }
            }
          } else if (t_s == 'type-query') {
            if (_.isEmpty(t_p.type)) {
              f_o.status = true
            } else {
              s = _.find(opt, function (o) {
                return o.id == t_p.type
              })
              if (!s) {
                t_p.type = f_o.id
                vm.setTabsWithParamsSecondary(opt)
                vm.updateHistory(f_o.id, t_s)
              } else {
                vm.setTabsWithParamsSecondary(opt)
              }
            }
          }
        },
        getParamsUrl() {
          let vm = this
          let uri = window.location.href.split('?')
          if (uri.length == 2)
          {
            let vars = uri[1].split('&')
            let getVars = {}
            let tmp = ''
            _.forEach(vars, function (v) {
              tmp = v.split('=')
              if(tmp.length == 2)
              getVars[tmp[0]] = tmp[1]
            })
            vm.params = getVars
          }
        },
        updateHistory(id, type) {
          let vm = this
          let searchParams = new URLSearchParams(window.location.search)
          if (type == 'register')
            searchParams.set("register", id);
          else if (type == 'type-query')
            searchParams.set("type", id);
          else {
            searchParams.set("error", 'undefined');
          }
          let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
          history.pushState(null, '', newRelativePathQuery);
        },
        setTabsWithParamsMain(o) {
          let vm = this
          _.forEach(o, function (v) {
            if (v.id == vm.params.register) {
              v.status = true
            } else {
              v.status = false
            }
          })
        },
        setTabsWithParamsSecondary(o) {
          let vm = this
          _.forEach(o, function (v) {
            if (v.id == vm.params.type) {
              v.status = true
            } else {
              v.status = false
            }
          })
        },
        isEmpty(o) {
          return _.isEmpty(o)
        },
        goToView(id) {
          document.getElementById(id).scrollIntoView({block: 'start', behavior: 'smooth'})
        },
        formatDate(d) {
          return moment(d).format('YYYY-MM-DD')
        },
        formatDateFromNow(d) {
          return moment(d).fromNow()
        },
        toast() {
          var x = document.getElementById("toast")
          x.className = "show";
          setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
        }
      }
  });
}

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
if(document.getElementById("app_vue") != undefined) {
	const app = new Vue({
    	el: '#app_vue'
	});
}



// WEBPACK FOOTER //
// ./resources/js/app.js